import { IconKeyboard } from "@tabler/icons";
import keywordsbasedonsearchintent from "../json/keywordsbasedonsearchintent";
import specifythesource from "../json/specifythesource";
import generaterelevanttopicstotarget from "../json/generaterelevanttopicstotarget";
import googlesearchconsole from "../json/googlesearchconsole";
import lsikeyword from "../json/lsikeyword";
import longtailkeywords from "../json/longtailkeywords";
import keywordresearch from "../json/keywordresearch";
import industryspecifickeywords from "../json/industryspecifickeywords";

// constant
const icons = {
  IconKeyboard,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const keywordsuggestion = {
  id: "keywordsuggestion",
  title: "Keyword Suggestion",
  caption: "Keyword Suggestion",
  type: "group",
  children: [
    {
      id: "keywordsuggestion",
      title: "Keyword Suggestion",
      type: "collapse",
      icon: icons.IconKeyboard,

      children: [
        {
          id: "keywords-based-on-search-intent",
          title: "Classify a list of keywords based on search intent",
          titleType: "collapse",
          type: "item",
          url: "/keywords-based-on-search-intent",
          target: false,
          breadcrumbs: true,
          endPoint:"ai/keywords",
          jsonobject: keywordsbasedonsearchintent,
          editorTitile:
            "A list of keywords classified based on their search intent",
          mainTitile: "Classify a list of keywords based on search intent",
          mainDescription:
            "This feature allows users to input a list of keywords, and the app classifies them based on their search intent (informational, navigational, transactional)",
        },
        {
          id: "specify-the-source",
          title: "Translate a list of keywords",
          titleType: "collapse",
          type: "item",
          url: "/specify-the-source",
          jsonobject: specifythesource,
          target: false,
          breadcrumbs: true,
          endPoint:"ai/languagetranslation",
          editorTitile: "A list of translated keywords in the target language",
          mainTitile: "Translate a list of keywords",
          mainDescription:
            "This feature would allow users to input a list of keywords in one language, and the app would translate them into another language.",
        },
        {
          id: "generate-relevant-topics-to-target",
          title: "Generate relevant topics to target",
          titleType: "collapse",
          type: "item",
          url: "/generate-relevant-topics-to-target",
          
          target: false,
          breadcrumbs: true,
          endPoint:"ai/relevantsites",
          jsonobject: generaterelevanttopicstotarget,
          editorTitile: "A list of relevant topics to target",
          mainTitile: "Generate relevant topics to target",
          mainDescription:
            "This feature allows users to input a topic or keyword, and the app generates a list of relevant topics to target.",
        },

        {
          id: "google-search-console",
          title:
            "Generate RegEx to filter Google Search Console Performance Report.",
          titleType: "collapse",
          type: "item",
          url: "/google-search-console",
          target: false,
          breadcrumbs: true,
          endPoint:"ai/regexfliter",
          jsonobject: googlesearchconsole,
          editorTitile:
            "For filtering the Google Search Console performance report, see this regex.",
          mainTitile:
            "Generate RegEx to filter Google Search Console Performance Report",
          mainDescription:
            "To filter the Google Search Console performance report, create a regex.",
        },
        {
          id: "lsikey-word",
          title: "LSI keywords",
          titleType: "collapse",
          type: "item",
          url: "/lsikey-word",
          target: false,
          breadcrumbs: true,
          endPoint:"ai/lsikeywords",
          jsonobject: lsikeyword,
          editorTitile:
            "A list of LSI keywords that could be used for SEO and content optimization",
          mainTitile: "LSI keywords",
          mainDescription:
            "This feature allows users to input a topic or keyword, and the app generates a list of LSI (Latent Semantic Indexing) keywords that are related to the input topic or keyword.",
        },
        {
          id: "longtail-keywords",
          title: "Long-tail keywords",
          titleType: "collapse",
          type: "item",
          url: "/longtail-keywords",
          target: false,
          breadcrumbs: true,
          endPoint:"ai/longkeywords",
          jsonobject: longtailkeywords,
          editorTitile:
            "A list of long-tail keywords that could be used for SEO and content optimization",
          mainTitile: "Long-tail keywords",
          mainDescription:
            "This feature allows users to input a topic or keyword, and the app generates a list of long-tail keywords (longer and more specific phrases) that are related to the input topic or keyword.",
        },
        {
          id: "keyword-research",
          title: "Keyword research",
          titleType: "collapse",
          type: "item",
          url: "/keyword-research",
          target: false,
          breadcrumbs: true,
          endPoint:"ai/keywordresearch",
          jsonobject: keywordresearch,
          editorTitile:
            "A list of related keywords that could be used for SEO and content optimization",
          mainTitile: "Keyword research",
          mainDescription:
            "This feature allows users to input a topic or keyword, and the app generates a list of long-tail keywords (longer and more specific phrases) that are related to the input topic or keyword.",
        },
        {
          id: "industry-specific-keywords",
          title: "industry-specific keywords",
          titleType: "collapse",
          type: "item",
          url: "/industry-specific-keywords",
          target: false,
          breadcrumbs: true,
          endPoint:"ai/indusrykeywords",
          jsonobject: industryspecifickeywords,
          editorTitile:
            "A list of industry-specific keywords that could be used for SEO and content optimization",
          mainTitile: "Industry-specific keywords",
          mainDescription:
            "This feature allows users to input a website's URL, and the app generates a list of keywords that are most relevant to the website's industry.",
        },
      ],
    },
  ],
};

export default keywordsuggestion;
